import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

export const gri_mixin = {
  data() {
    return {
      is_unlinked: false
    };
  },
  computed: {
    ...mapState('report_list', ['report_code', 'standard_mode']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapGetters('report_contents', ['data_table_header_style', 'data_table_cell_style']),
    ...mapState('report_contents', ['report_contents']),
    ...mapGetters('data_tables', ['hashed_data_tables']),
    ...mapGetters('documents', ['hashed_docs']),
    ...mapGetters('business_cases', ['hashed_business_cases']),
    ...mapState('report_list', ['lang', 'view_mode']),
    ...mapState('gri2021_report_view', ['report_structure'])
  },
  methods: {
    ...mapMutations('cursor', [
      'update_editing_gri_code',
      'change_document_mode',
      'update_editing_dc_code'
    ]),
    ...mapActions('data_tables', ['updateDataTableRelation']),
    ...mapActions('documents', ['updateDocumentRelation']),
    ...mapActions('business_cases', ['updateBusinessCaseRelation']),
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),
    getUniqueTopicsByCategoryIds(category_id) {
      const filtered_structure = this.report_structure.filter(
        item => item.category_id == category_id
      );
      const unique_topics = [];
      filtered_structure.forEach(item => {
        if (
          unique_topics.findIndex(x => {
            return x.topic_id == item.topic_id;
          }) < 0
        ) {
          unique_topics.push({
            category_id: item.category_id,
            category_name: item.category_name,
            category_name_e: item.category_name_e,
            topic_id: item.topic_id,
            topic_name: item.topic_name,
            topic_name_e: item.topic_name_e,
            topic_publication_date: item.topic_publication_date
          });
        }
      });
      return unique_topics;
    },
    getUniqueSubtopicsByCategoryIds(category_id) {
      const filtered_structure = this.report_structure.filter(
        item => item.category_id == category_id
      );
      const unique_subtopics = [];
      filtered_structure.forEach(item => {
        if (
          unique_subtopics.findIndex(x => {
            return x.subtopic_code == item.subtopic_code;
          }) < 0
        ) {
          unique_subtopics.push({
            category_id: item.category_id,
            category_name: item.category_name,
            category_name_e: item.category_name_e,
            subtopic_code: item.subtopic_code,
            subtopic_name: item.subtopic_name,
            subtopic_name_e: item.subtopic_name_e,
            topic_publication_date: item.topic_publication_date
          });
        }
      });

      return unique_subtopics;
    },
    getGRIContentsByTopicIds(topic_id) {
      const filtered_structure = this.report_structure.filter(item => item.topic_id == topic_id);
      return filtered_structure;
    },
    getGRIContentsBySubtopicCodes(subtopic_code) {
      const filtered_structure = this.report_structure.filter(
        item => item.subtopic_code == subtopic_code
      );
      this.gri_data_loading = true;
      return filtered_structure;
    },
    getGRIContentsByCategoryIds(category_id) {
      const filtered_structure = this.report_structure.filter(
        item => item.category_id == category_id
      );
      return filtered_structure;
    },
    scrollToHash() {
      this.$nextTick(() => {
        const hash = window.location.hash;
        if (hash) {
          const element = document.querySelector(hash);

          if (element && element !== 'null') {
            element.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
        }
      });
    },
    changeWritingMode(gri_code) {
      if (!this.handleEdit()) {
        return;
      }
      this.initiateWritingMode(gri_code);
      this.is_writing_direct[gri_code] = true;
    },

    // 데이터 테이블, 비즈니스 사례, 문서 및 링크 추가-삭제-편집
    addDocuments(code_id) {
      if (!this.handleEdit()) {
        return;
      }
      this.change_document_mode(code_id?.type ? code_id?.type : 'file');
      this.update_editing_gri_code(code_id.gri_code);
      this.$emit('add-documents', code_id.document_id); //WritingMaster로 이벤트 보내서 modal open
    },
    addTables(code_id) {
      if (!this.handleEdit()) {
        return;
      }
      this.update_editing_gri_code(code_id?.gri_code);
      this.$emit('add-tables', code_id?.table_id); //WritingMaster로 이벤트 보내서 modal open
    },
    addTablesFromDC(lv1_info) {
      // FromDC는 Data Center 전용 메소드
      if (!this.handleEdit()) {
        return;
      }
      this.$emit('add-tables', lv1_info?.table_id);
    },
    addChartsFromDC(lv1_info) {
      // FromDC는 Data Center 전용 메소드
      if (!this.handleEdit()) {
        return;
      }
      this.update_editing_dc_code(lv1_info?.gri_code);
      this.$emit('add-dc-tables', lv1_info?.table_id);
    },
    addBusinessCases(code_id) {
      if (!this.handleEdit()) {
        return;
      }
      this.update_editing_gri_code(code_id.gri_code);
      this.$emit('add-business-cases', code_id.business_case_id); //WritingMaster로 이벤트 보내서 modal open
    },
    addCharts() {
      if (!this.handleEdit()) {
        return;
      }
    },
    handleUnlink(code_id) {
      if (!this.handleEdit()) {
        return;
      }
      this.is_unlinked = true;
      const xx = this.report_contents.findIndex(yy => yy.gri_code == code_id.gri_code);
      if (xx > -1) {
        const temp_payload = {};
        if (code_id.table_id > 0) {
          temp_payload[code_id.table_id] = false;
          this.updateDataTableRelation({
            report_code: this.report_code,
            gri_code: this.report_contents[xx].gri_code,
            link_payload: temp_payload,
            framework: this.standard_mode
          });
        } else if (code_id.document_id > 0) {
          temp_payload[code_id.document_id] = false;
          this.updateDocumentRelation({
            report_code: this.report_code,
            gri_code: this.report_contents[xx].gri_code,
            link_payload: temp_payload,
            framework: this.standard_mode
          });
        } else if (code_id.business_case_id > 0) {
          temp_payload[code_id.business_case_id] = false;
          this.updateBusinessCaseRelation({
            report_code: this.report_code,
            gri_code: this.report_contents[xx].gri_code,
            link_payload: temp_payload,
            framework: this.standard_mode
          });
        }
      } else {
        if (this.standard_mode.includes('SASB') || this.standard_mode.includes('TCFD')) {
          const temp_payload = {};
          if (code_id.table_id > 0) {
            temp_payload[code_id.table_id] = false;
            this.updateDataTableRelation({
              report_code: this.report_code,
              gri_code: code_id.gri_code,
              link_payload: temp_payload,
              framework: this.standard_mode
            });
          } else if (code_id.document_id > 0) {
            temp_payload[code_id.document_id] = false;
            this.updateDocumentRelation({
              report_code: this.report_code,
              gri_code: code_id.gri_code,
              link_payload: temp_payload,
              framework: this.standard_mode
            });
          } else if (code_id.business_case_id > 0) {
            temp_payload[code_id.business_case_id] = false;
            this.updateBusinessCaseRelation({
              report_code: this.report_code,
              gri_code: code_id.gri_code,
              link_payload: temp_payload,
              framework: this.standard_mode
            });
          }
        }
      }
      this.is_unlinked = false;
    },
    handleEdit() {
      if (!this.selected_report.is_able_to_edit) window.alert('서비스 결제가 필요합니다');
      return this.selected_report.is_able_to_edit;
    },
    goHash(code, item = 'GRI') {
      let hash_code = '#w' + code;
      if (item === 'GRI') {
        if (code.includes('_')) {
          const codePart = code.split('_')[1];
          const hundredValue = Math.floor(parseInt(codePart, 10) / 100) * 100;
          let routeName = 'Gri' + hundredValue;
          // gri_100인 경우 Gri100_2021로 변경
          if (routeName === 'Gri100') routeName = 'Gri100_2021';
          this.$router.push({ name: routeName, hash: hash_code });
        } else {
          let routeName;
          if (code.split('-')[0].length > 1) {
            routeName = 'Gri' + code.slice(0, 1) * 100;
          } else {
            routeName = 'Gri' + code.split('-')[0];
          }
          // gri_100인 경우 Gri100_2021로 변경
          if (routeName === 'Gri100') routeName = 'Gri100_2021';
          this.$router.push({ name: routeName, hash: hash_code });
        }
      } else if (item === 'SASB') {
        this.$router.push({
          path: '/write_report/sasb',
          hash: hash_code.replace('.', '_')
        });
      } else if (item === 'TCFD') {
        this.$router.push('/write_report/tcfd' + hash_code);
      } else if (item === 'DATA_CENTER') {
        hash_code = '#w' + code.lv3_info.key;
        this.$router.push({
          path: '/write_report/data_centers',
          hash: hash_code.replace('.', '_')
        });
      } else if (item === 'STORY_BOARD') {
        this.update_selected_lv1({ lv1_info: code['sb_toc_lv1'], view_mode: this.view_mode });
        this.update_selected_lv2({ lv2_info: code['sb_toc_lv2'], view_mode: this.view_mode });
        hash_code = '#sr_content_' + code.id;
        this.$router.push({
          path: '/write_report/story_board',
          query: {
            lv1: code['sb_toc_lv1']['name'],
            lv2: code['sb_toc_lv2']['name']
          },
          hash: hash_code
        });
      }
    },
    getSameLength(o_array, index, key, header) {
      let rowspan = 1;
      const key_idx = header.findIndex(x => x == key);
      for (let i = index; i < o_array.length; i++) {
        if (i + 1 >= o_array.length) {
          return rowspan;
        }
        if (
          o_array[i][key] !== '' &&
          o_array[i + 1][key] !== '' &&
          o_array[i][key] === o_array[i + 1][key] &&
          key_idx == 0
        ) {
          rowspan += 1;
        } else {
          return rowspan;
        }
      }
    },
    differentPrevious(o_array, index, key, header) {
      if (index - 1 < 0) return true;
      const key_idx = header.findIndex(x => x == key);
      if (
        o_array[index][key] !== '' &&
        o_array[index][key] === o_array[index - 1][key] &&
        key_idx == 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    getValueFromObject(object, key) {
      if (Object.keys(object).includes(key)) {
        return object[key];
      } else {
        return null;
      }
    },
    navigateToSelectGriIndicators(name, hash) {
      this.$router.push({ name, hash }).then(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 1000);
        });
      });
    },

    getDocumentLink(doc) {
      const prefix = 'https://report.qesg.co.kr/v';

      if (doc?.type === 'file') {
        return this.$store.state.static_host + (this.lang === 'ENG' ? doc?.path_e : doc?.path);
      } else if (doc?.type === 'link') {
        return this.lang === 'ENG' ? doc?.link_e : doc?.link;
      } else if (doc?.type === 'storyboard') {
        return this.getStoryboardLink(doc);
      } else {
        return '#';
      }
    },
    getStoryboardLink(doc) {
      if (this.selected_report && this.selected_report.state >= 4) {
        return this.lang != 'ENG' ? doc?.link : doc?.link_e;
      } else {
        const { lv1, lv2, lv3 } = this.extractLvFromLink(doc.link);
        if (lv1 && lv2) {
          const routeOptions = {
            name: 'FullView',
            query: {
              lv1: lv1,
              lv2: lv2,
              ...(this.lang === 'ENG' ? { l: 'ENG' } : {})
            }
          };

          if (lv3) {
            routeOptions.hash = lv3;
          }

          const fullViewPath = this.$router.resolve(routeOptions).href;
          return fullViewPath;
        } else {
          return null;
        }
      }
    },
    extractLvFromLink(link) {
      try {
        const url = new URL(link, window.location.origin); // 상대 경로인 경우를 대비하여 베이스 URL을 지정
        const lv1 = url.searchParams.get('lv1');
        const lv2 = url.searchParams.get('lv2');
        const lv3 = url.hash ? url.hash : null;
        return { lv1, lv2, lv3 };
      } catch (error) {
        error.message = '[url에서 주제추출]' + error.message;
        this.$Sentry.captureException(error);
        return { lv1: null, lv2: null, lv3: null };
      }
    },
    getDocumentIcon(type) {
      switch (type) {
        case 'file':
          return 'file-earmark-text';
        case 'link':
          return 'link-45deg';
        case 'storyboard':
          return 'box-arrow-up-right';
        default:
          return 'file-earmark-text'; // Default icon or handle as needed
      }
    },
    /**
     * dt 테이블의 셀 병합 처리 후 보이도록 반환
     */
    visibleCells(tableId) {
      const table = this.hashed_data_tables[tableId];

      const hideHeaderVar = this.hideHeader(tableId);
      if (!table) return [];
      // 셀 객체 생성

      const cells = table.contents.map((row, r) =>
        table.header.map((prop, c) => {
          const key = `${r}, ${c}`;
          const meta = table.options?.[key] || {};

          const mergedStyle = {
            ...this.data_table_cell_style,
            ...meta
          };
          const [top, bottom, left, right] = mergedStyle.borderSide;
          return {
            rowIndex: r,
            colIndex: c,
            value: row[prop],
            colspan: meta.colspan || 1,
            rowspan: meta.rowspan || 1,
            hidden: meta.hidden || false,
            width: hideHeaderVar ? table.options?.[`-1, ${c}`]?.width : '',
            style: {
              ...mergedStyle,
              border: `${mergedStyle.borderWidth}px ${mergedStyle.borderType} ${mergedStyle.borderColor} !important`,
              'border-top': `${top ? 1 : 0} !important`,
              'border-bottom': `${bottom ? 1 : 0} !important`,
              'border-left': `${left ? 1 : 0} !important`,
              'border-right': `${right ? 1 : 0} !important`,
              backgroundColor: `${mergedStyle.backgroundColor} !important`,
              verticalAlign: mergedStyle.verticalAlign ?? 'top',
              textAlign: mergedStyle.textAlign ?? 'start',
              width: hideHeaderVar ? table.options?.[`-1, ${c}`]?.width + '%' : 'auto'
            }
          };
        })
      );

      for (let r = 0; r < cells.length; r++) {
        const cell = cells[r][0];
        if (cell.hidden) continue;

        // 값 기준으로 계산할 span
        let valueSpan = 1;
        for (let r2 = r + 1; r2 < cells.length; r2++) {
          const next = cells[r2][0];
          if (!next.hidden && next.value === cell.value) {
            valueSpan++;
          } else {
            break;
          }
        }

        // style.rowspan 가져오기
        const styleKey = `${r}, 0`;
        const style = table.options?.[styleKey] || {};
        const styleSpan = style.rowspan || 0;

        // 둘 중 큰 값으로 최종 span 결정
        const finalSpan = Math.max(valueSpan, styleSpan);

        // 숨길 셀 처리
        for (let k = 1; k < finalSpan; k++) {
          if (r + k < cells.length) {
            cells[r + k][0].hidden = true;
          }
        }

        cell.rowspan = finalSpan;
      }

      return cells.map(row => row.filter(cell => !cell.hidden));
    },

    getHeaderStyle(tableId, row, col) {
      const tbl = this.hashed_data_tables[tableId];
      const key = `${row}, ${col}`;
      const option = tbl.options?.[key];
      const baseStyle = this.data_table_header_style;

      const mergedStyle = {
        ...baseStyle,
        ...option
      };

      const [top = 1, bottom = 1, left = 1, right = 1] = mergedStyle?.borderSide || [];

      const widthValue = mergedStyle?.width ?? (100 / tbl.header.length).toFixed(2);

      return {
        border: `${mergedStyle?.borderWidth}px ${mergedStyle?.borderType} ${mergedStyle?.borderColor} !important`,
        'border-top': `${top ? 1 : 0} !important`,
        'border-bottom': `${bottom ? 1 : 0} !important`,
        'border-left': `${left ? 1 : 0} !important`,
        'border-right': `${right ? 1 : 0} !important`,
        width: `${widthValue}%`,
        backgroundColor: mergedStyle?.backgroundColor
          ? `${mergedStyle?.backgroundColor} !important`
          : null,
        verticalAlign: option?.verticalAlign ? `${option?.verticalAlign} !important` : 'top',
        textAlign: option?.textAlign ? `${option?.textAlign} !important` : 'start'
      };
    },

    hideHeader(table_id, lang = 'KOR') {
      const table = this.hashed_data_tables[table_id];

      if (!table) {
        return false;
      }
      const options =
        lang === 'KOR'
          ? table.options
          : table.options_e !== undefined
          ? table.options_e
          : table.options;
      return !!(table && options && options?.['_header_hidden'] !== undefined);
    }
  }
};
